module.exports = __webpack_public_path__ + "img/GAME_SWEEPLEAVES1.bca95b4d.jpg";